module.exports = __webpack_public_path__ + "img/eye-slash.ecc4dff2.svg";